import { indexBy, prop } from 'ramda';

import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const fetchAudits = (state, { meta, payload }) => {
  if (meta.source === 'link-audit') {
    return indexBy(prop('rel'))(payload.links);
  }
  return state;
};

const clearIds = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_SUCCESS]: fetchAudits,
  [actionTypes.CLEAR_COLLECTION]: clearIds,
});
